import { RootState } from "common/reducers";
import { authorizedToken, token } from "common/selectors/token.selectors";
import { currentOrgId } from "common/selectors/org.selectors";
import { List } from "immutable";
import { createSelector } from "reselect";
import { currentUserOrgId, currentUserPermissions } from "src/common/selectors/user.selectors";

const EMPTY_OPTIONS = List<string>();

export const occPayProviderActive = (state: RootState) => {
  return (
    authorizedToken(state, { orgId: currentOrgId(state) ?? currentUserOrgId(state), kind: "occ_pay" })?.authorized ||
    false
  );
};

export const occPayPaymentOption = (state: RootState): List<string> => {
  return (token(state, { kind: "occ_pay" })?.getIn(["data", "payment_options"]) as List<string>) || EMPTY_OPTIONS;
};

export interface OccPayCapabilities {
  canOnscreen: boolean;
  canEmailText: boolean;
  canSaveMethod: boolean;
}

export const occPayCapabilities = createSelector(
  [currentUserPermissions, occPayPaymentOption],
  (permissions, options): OccPayCapabilities => ({
    canOnscreen: Boolean(permissions?.get("payment")?.includes("onscreen")) && options.includes("onscreen"),
    canEmailText: Boolean(permissions?.get("payment")?.includes("email_text")) && options.includes("email_text_to_pay"),
    canSaveMethod:
      Boolean(permissions?.get("payment_method")?.includes("create")) && options.includes("store_payment_method_only"),
  }),
);
